import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Tiles/Tiles';
import {File as FWFile} from 'FW/Models/File';

class Tiles extends React.Component {
  render() {
    let section = this.props.section;
    const tileHeight = section.prop('options').tile_height;
    const tilesPerRow = section.prop('options').tiles_per_row;
    const possibleThumbnails = [150, 300, 800, 1280, 2880];
    const thumbnailSize = this.props.chooseNearest(
      Math.max($(window).width() / tilesPerRow, tileHeight),
      possibleThumbnails
    );
    let tiles = section.prop('tiles').map((tile, i) => {
      let backgroundUrl = null;
      if (tile.background_file_id) {
        let background = FWFile.findOrCreate({id: tile.background_file_id});
        if (
          !background.get('created_at') &&
          !this.props.filesFetched.includes(tile.background_file_id)
        ) {
          this.props.filesFetched.push(tile.background_file_id);
          let self = this;
          background.fetch().then(function() {
            self.forceUpdate();
          });
        }
        backgroundUrl = background.helper.thumbnailUrl(thumbnailSize);
      }

      let href = Helper.fixHref(tile.href);
      let target =
        href && href.indexOf('/site') === 0 && FW.inEditor()
          ? '_parent'
          : tile.target;

      let columns = tilesPerRow ? 12 / tilesPerRow : 4;
      let tileClass = 'col-md-' + Math.max(Math.min(columns, 12), 1);
      let onClick = null;
      if (this.props.editingClicked) {
        onClick = function(e) {
          e.preventDefault();
        };
        href = null;
      } else if (FW.inEditor()) {
        onClick = function(e) {
          e.stopPropagation();
        };
      }
      const tilePadding = section.ls('padding');
      console.log(tilePadding);
      return (
        <div
          className={tileClass}
          style={{overflow: 'hidden', margin: 0, padding: tilePadding}}
        >
          <div
            className="folio-item wow fadeInLeftBig animated"
            data-wow-duration="1000ms"
            data-wow-delay="400ms"
            style={{
              visibility: 'visible',
              animationDuration: '1000ms',
              animationDelay: '400ms',
              animationName: 'fadeInLeftBig',
              height: tileHeight
            }}
          >
            <div
              className="folio-image"
              style={{height: tileHeight, minWidth: '100%'}}
            >
              {backgroundUrl ? (
                <img
                  style={{height: tileHeight, minWidth: '100%'}}
                  src={backgroundUrl}
                  alt={'tile-' + i}
                />
              ) : null}
            </div>
            <div className="overlay" style={{height: tileHeight}}>
              <div className="overlay-content">
                <div className="overlay-text">
                  <div className="folio-info">
                    <InlineEditableElement
                      fontFamilyChanged={this.props.fontFamilyChanged.bind(
                        this
                      )}
                      html={tile.content}
                      onChange={this.props.tileChanged.bind(this, i)}
                      inlineEditingEnabled={this.props.editingClicked}
                    />
                  </div>
                  <div className="folio-overview">
                    <span className="folio-link">
                      <a
                        className="folio-read-more"
                        onClick={onClick}
                        href={href}
                        target={target}
                      >
                        <i className="fa fa-link" />
                      </a>
                    </span>
                    <span className="folio-expand">
                      <a
                        href={'/file/' + tile.background_file_id}
                        data-lightbox="portfolio"
                      >
                        <i className="fa fa-camera" />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
    this.props.fixSizeHack();
    const editButton =
      FW.inEditor() && !this.props.inlineEditingEnabled
        ? this.props.renderEditButton()
        : null;
    return (
      <div
        id="portfolio"
        className="tileSection clearfix"
        style={{padding: 0, margin: 0}}
      >
        {editButton}
        {tiles}
      </div>
    );
  }
}

export default hoc(Tiles);
